document.addEventListener("DOMContentLoaded", () => {
  const deliveryCutoffBar = document.getElementById("delivery-cutoff-bar");
  const deliveryCutoffText = document.getElementById("delivery-cutoff-bar__countdown-text");

  const deliveryCutoffPDPEl = document.getElementById("delivery-cutoff-pdp");
  const deliveryCutoffPDPText = document.getElementById("delivery-cutoff-pdp__countdown-text");

  let bankHolidays = [];

  const bankHoliday1Timestamp = Date.parse("2024/12/25");
  const bankHoliday1 = new Date(bankHoliday1Timestamp);

  if(bankHoliday1.toString() != "Invalid Date") {
    bankHolidays.push(bankHoliday1);
  }
  
  const bankHoliday2Timestamp = Date.parse("2024/12/26");
  const bankHoliday2 = new Date(bankHoliday2Timestamp);
  
  if(bankHoliday2.toString() != "Invalid Date") {
    bankHolidays.push(bankHoliday2);
  }

  const bankHoliday3Timestamp = Date.parse("2025/01/01");
  const bankHoliday3 = new Date(bankHoliday3Timestamp);
  
  if(bankHoliday3.toString() != "Invalid Date") {
    bankHolidays.push(bankHoliday3);
  }

  const bankHoliday4Timestamp = Date.parse("2025/04/18");
  const bankHoliday4 = new Date(bankHoliday4Timestamp);
  
  if(bankHoliday4.toString() != "Invalid Date") {
    bankHolidays.push(bankHoliday4);
  }

  const bankHoliday5Timestamp = Date.parse("2025/04/21");
  const bankHoliday5 = new Date(bankHoliday5Timestamp);
 
  if(bankHoliday5.toString() != "Invalid Date") {
    bankHolidays.push(bankHoliday5);
  }

  const bankHoliday6Timestamp = Date.parse("2025/05/05");
  const bankHoliday6 = new Date(bankHoliday6Timestamp);
  
  if(bankHoliday6.toString() != "Invalid Date") {
    bankHolidays.push(bankHoliday6);
  }

  const bankHoliday7Timestamp = Date.parse("2025/05/26");
  const bankHoliday7 = new Date(bankHoliday7Timestamp);
  
  if(bankHoliday7.toString() != "Invalid Date") {
    bankHolidays.push(bankHoliday7);
  }

  const bankHoliday8Timestamp = Date.parse("2025/08/25");
  const bankHoliday8 = new Date(bankHoliday8Timestamp);
  
  if(bankHoliday8.toString() != "Invalid Date") {
    bankHolidays.push(bankHoliday8);
  }

  const bankHoliday9Timestamp = Date.parse("2025/12/25");
  const bankHoliday9 = new Date(bankHoliday9Timestamp);
  
  if(bankHoliday9.toString() != "Invalid Date") {
    bankHolidays.push(bankHoliday9);
  }

  const bankHoliday10Timestamp = Date.parse("2025/12/26");
  const bankHoliday10 = new Date(bankHoliday10Timestamp);
  
  if(bankHoliday10.toString() != "Invalid Date") {
    bankHolidays.push(bankHoliday10);
  }

  function padNumbers(num) {
      num = num.toString();
      while (num.length < 2) num = "0" + num;
      return num;
  }

  function isTodayBankHoliday(today, bankHolidays) {
    let result = false;

    bankHolidays.forEach((bankHoliday) => {
      if(today.getDate() == bankHoliday.getDate() && today.getMonth() == bankHoliday.getMonth() && today.getFullYear() == bankHoliday.getFullYear()) {
        result = true;
      }
    });

    return result;
  }

  let f = setInterval(function() {
    let now = new Date(); 
    let day = now.getDay();
    let hour = now.getHours();

    const isBankHolidayToday = isTodayBankHoliday(now, bankHolidays);

    const dayOfWeekString = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
    const cutoffDeadlineHour = 12;

    if([1,2,3].includes(day) || (day == 4 && hour < cutoffDeadlineHour)) {
      const orderCutoffDate = new Date(now);
      const orderDeliveryDate = new Date(now);
      

      if(hour < cutoffDeadlineHour && isBankHolidayToday == false) {
        orderCutoffDate.setDate(orderCutoffDate.getDate());
        orderDeliveryDate.setDate(orderDeliveryDate.getDate() + 1);
      } else {
        orderCutoffDate.setDate(orderCutoffDate.getDate() + 1);
        orderDeliveryDate.setDate(orderDeliveryDate.getDate() + 2);
      }
     
      orderCutoffDate.setHours(cutoffDeadlineHour, 0, 0);

      const isBankHolidayOnDeliveryDate = isTodayBankHoliday(orderDeliveryDate, bankHolidays);

      //console.log(`delivery date ${orderDeliveryDate}`);
      //console.log(`isBankHolidayOnDeliveryDate ${isBankHolidayOnDeliveryDate}`);

      if(isBankHolidayOnDeliveryDate == false) {
        // Find the distance between now and the count down date
        let distance = orderCutoffDate - now;
        let cutoffDaysToGo = Math.floor(distance / (1000 * 60 * 60 * 24));
        let cutoffHoursToGo = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + (24 * cutoffDaysToGo);
        let cutoffMinutesToGo = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let cutoffSecondsToGo = Math.floor((distance % (1000 * 60)) / 1000);

        if(hour < cutoffDeadlineHour && isBankHolidayToday == false) {
          let cutoffText = `<b>${cutoffHoursToGo}h:${padNumbers(cutoffMinutesToGo)}m:${padNumbers(cutoffSecondsToGo)}s</b> for <b>Next Day</b> delivery on <b>${dayOfWeekString[orderDeliveryDate.getDay()]}</b>`;

          if(deliveryCutoffText !== null) {
            deliveryCutoffText.innerHTML = cutoffText;
          }
          
          if(deliveryCutoffPDPText !== null) {
            deliveryCutoffPDPText.innerHTML = cutoffText;
          }        

        } else {    
          let cutoffText = `<b>${cutoffHoursToGo}h:${padNumbers(cutoffMinutesToGo)}m:${padNumbers(cutoffSecondsToGo)}s</b> for delivery on <b>${dayOfWeekString[orderDeliveryDate.getDay()]}</b>`;
          
          if(deliveryCutoffText !== null) {
            deliveryCutoffText.innerHTML = cutoffText;
          }

          if(deliveryCutoffPDPText !== null) {
            deliveryCutoffPDPText.innerHTML = cutoffText;
          }        
        }

        if(deliveryCutoffBar !== null) {
          deliveryCutoffBar.style.display = "block";
        }

        if(deliveryCutoffPDPEl !== null) {
          deliveryCutoffPDPEl.style.display = "block";
        }
        
      } else {
        // Hide if delivery date is bank holiday 

        if(deliveryCutoffBar !== null) {
          deliveryCutoffBar.style.display = "none";
        }

        if(deliveryCutoffPDPEl !== null) {
          deliveryCutoffPDPEl.style.display = "none";
        }
      
      }
    } else {
      if(deliveryCutoffBar !== null) {
        deliveryCutoffBar.style.display = "none";
      }

      if(deliveryCutoffBar !== null) {
        deliveryCutoffBar.style.display = "none";
      }       
       
    }

  }, 1000);

 });